export const formatBookingClientName = (booking) =>
    [booking?.first_name, booking?.insertion, booking?.last_name]
        .map((part) => String(part || "").trim())
        .filter(Boolean)
        .join(" ");
